import { BlogSection } from '@/types/blog';

export const deutschePerspektive: BlogSection = {
  id: 'deutsche-perspektive',
  title: 'Die deutsche Perspektive: Steuer, Kosten, Realität',
  content: `
    <h3>Steuerliche Gleichstellung seit 2018</h3>

    <p>Seit der Investmentsteuerreform 2018 gibt es <strong>keine steuerlichen Vorteile</strong> mehr für thesaurierende gegenüber ausschüttenden Fonds. Die Vorabpauschale 2024 (Basiszins 2,29%) bedeutet <strong>maximal 33 Euro Steuer per 10.000 Euro Aktien-ETF</strong> (Januar 2025). Überschaubar und bei Verkauf anrechenbar. Der erhöhte Sparerpauschbetrag 2025 (<strong>1.000 Euro Single, 2.000 Euro verheiratet</strong>) hilft zusätzlich.</p>

    <h3>Kosten: Der 36.000-Euro-Unterschied</h3>

    <p>Konkretes Szenario (20 Jahre, 500 Euro/Monat Sparplan):</p>
    <ul>
      <li><strong>ETF (0,20% TER) via Neobroker:</strong> rund 5.000 Euro Kosten</li>
      <li><strong>Aktiver Fonds (1,5% TER plus 5% Ausgabeaufschlag):</strong> rund 41.000 Euro Kosten</li>
      <li><strong>Differenz: 36.000 Euro weniger Vermögen</strong></li>
    </ul>

    <p>DAX-ETFs kosten heute <strong>0,08 bis 0,16%</strong> (Lyxor Core DAX 0,08%), World-ETFs <strong>0,12 bis 0,20%</strong>. Neobroker (Trade Republic, Scalable Capital) verlangen <strong>0 Euro</strong> für Sparpläne. Die Kostenrevolution ist real.</p>

    <h3>Aber: Wenige deutsche Aktive schaffen es dauerhaft</h3>

    <p>DWS Deutschland erzielte <strong>8,2% p.a. über 25 Jahre</strong> (DAX: 6,7%). Fondak hat die beste Langfrist-Rendite aller deutschen Aktienfonds. Aber SPIVA Deutschland 2017: <strong>Rund 90% deutscher Aktienfonds unterperformten MSCI Germany</strong>. Survivorship Bias: Viele verschwinden unbemerkt.</p>
  `
};
